import Pharmacy from "./../../../views/pharmacy/Pharmacy"
export const pharmacy = {
    path: '/pharmacy',
    name: 'Pharmacy',
    component: Pharmacy
  }


// WEBPACK FOOTER //
// ./src/router/index/pharmacy/index.js